import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchLensTintsCases() {
    const url = `/Account/GetCoatsTintsandCasesList`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Lenses: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchUserLensTintsCases() {
    const url = `/EndUser/GetCoatsTintsandCases`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch user Lenses: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function deleteUserLensTintsCases(addonId) {
    const url = `/EndUser/DeleteCoatsTintsandCases/${encodeURIComponent(addonId)}`;

    try {
        const response = await buildRequest(url, 'DELETE');

        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to delete lens tints cases to account: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to delete lens tints cases to account: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function addUserLensTintsCases(email, addonName, addonId) {
    const url = `/EndUser/AddCoatsTintsandCases`;

    const payload = {
        addonaddress: email,
        addonname: addonName,
        addonselectpartcode: addonId,
        addonwhopays: "employer"
    };

    try {
        const response = await buildRequest(url, 'POST', payload);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to add lens tints cases to account: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to add lens tints cases to account: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}